import { HttpErrorResponse } from '@angular/common/http';
import {
  PU_ERROR_CODE_HEADER,
  SSO_ERROR_CODES,
  SSO_FALLBACK_ERROR_CODE,
  SsoErrorCode,
} from '~shared/models/general/sso.model';

/**
 * Code métier d'un échec de connexion déléguée, à traduire sous
 * SSO.ERROR.<code>. Jamais le détail technique : un code inconnu retombe sur
 * le message générique.
 */
export function ssoErrorCode(error: unknown): SsoErrorCode {
  const code =
    error instanceof HttpErrorResponse
      ? error.headers?.get(PU_ERROR_CODE_HEADER)
      : null;

  return (
    SSO_ERROR_CODES.find((known) => known === code) ?? SSO_FALLBACK_ERROR_CODE
  );
}
